import { Breadcrumbs as NetfrontBreadcrumbs } from '@netfront/ui-library';
import Link from 'next/link';
import { IconHome } from '../Icons/IconHome';
import { BreadcrumbProps } from './Breadcrumbs.interfaces';

export const Breadcrumbs = ({ isAuthenticated, items }: BreadcrumbProps) => {
  return (
    <NetfrontBreadcrumbs
      itemDivider={<span>|</span>}
      items={[
        {
          ...(isAuthenticated
            ? {
                content: (
                  <Link className="w-5" href="/console">
                    <span className="sr-only">Dashboard</span>
                    <IconHome />
                  </Link>
                ),
                key: 'dashboard',
              }
            : {
                content: (
                  <Link className="w-5" href="/">
                    <span className="sr-only">Home</span>
                    <IconHome />
                  </Link>
                ),
                key: 'home',
              }),
        },
        ...items,
      ]}
    />
  );
};
